var $class="se2--banner-one-slide-with-figures",$name="BannerOneSlideWithFigures",$path="app/components/BannerOneSlideWithFigures/index.js",$this={$class,$name,$path,};import 'app/modules/accessibility';
import shell from 'app/modules/shell';

import 'app/partials/image';
import 'app/partials/productSelector';

import gsap from 'gsap';

export default shell.registerComponent($this, ({ mount, configs, subscribeToMessage, settings }) => {
  mount((element) => {
    const animationDescrtiptionSelector = '.description.animated';
    const animationSubtitleSelector = '.subtitle.animated';
    const animationTitleSelector = '.title.number.animated:not(.integer)';
    const animationTitleIntegerSelector = '.title.number.integer.animated';
    const secondaryBlockSelector = '.secondary-block-container';

    const animationDescrtiptionElements = element.querySelectorAll(animationDescrtiptionSelector);
    const animationSubtitleElements = element.querySelectorAll(animationSubtitleSelector);
    const animationTitleElements = element.querySelectorAll(animationTitleSelector);
    const animationTitleIntegerElements = element.querySelectorAll(animationTitleIntegerSelector);
    const secondaryBlockElement = element.querySelector(secondaryBlockSelector);

    const launchContentAndControlsAnimations = () => {
      secondaryBlockElement?.classList.remove('unshown');
      const revealTimeline = gsap.timeline({ scrollTrigger: {
        trigger: element,
        start: '+=50% bottom',
        end: 'bottom bottom',
      } });

      revealTimeline.fromTo(animationDescrtiptionElements,
        { opacity: 0 },
        { opacity: 1, duration: 2 }, 1);
      revealTimeline.from(animationTitleElements, {
        textContent: 0,
        duration: 1,
        snap: { textContent: 0.1 },
      }, 1);
      revealTimeline.from(animationTitleIntegerElements, {
        textContent: 0,
        duration: 1,
        snap: { textContent: 1 },
      }, 1);
      revealTimeline.fromTo(animationSubtitleElements,
        { opacity: 0 },
        { opacity: 1, duration: 2 }, 2);
    };

    const onAccessibilityToggle = () => {
      if (settings.accessibility) {
        secondaryBlockElement?.classList.remove('unshown');
        return;
      }

      launchContentAndControlsAnimations();
    };

    subscribeToMessage(configs.messages.accessibility, onAccessibilityToggle);
    onAccessibilityToggle();
  });
});
